import api from '@/services/api';

import { type ErrorData } from '../types';

const BASE_URL = 'error';

export const logError = async (data: ErrorData) => {
  await api.post(`${BASE_URL}/log-error`, data);
};
